import {Component} from 'react';
import {Image, Table} from 'react-bootstrap';

import CONFIG from '../global/libs/CONFIG.js';
import {DEPT_DATA, DEPT_HIERARCHY} from '../global/libs/departmentUtil.js';

import AppNavbar from './AppNavbar.js';
import AppAlert from './AppAlert.js';
import './AppJumbotron.css';
import {DESIGN} from '../global/libs/CONFIG.js';

import TreeView from '../global/treeview-react-bootstrap/src/index.jsx';
import './MultiDepartment.css';
import './Common.css';
import $ from 'jquery';

import PropTypes from 'prop-types';

const NOT_APPLICABLE = DESIGN.BUTTON_NOT_SELECT_CATEGORY_GROUP;

var Link = require('react-router-dom').Link;

const divStyle = {
  margin: '20px',
  padding: '10px',
  border: '1px solid #ddd',
  wordBreak: 'break-all'
};
const messageStyle = {
  fontSize: 'large'
};

function unescapeHTML(str) {
  // HTMLエスケープされた文字を元に戻す
  // http://blog.tojiru.net/article/211339637.html
  var div = document.createElement('div');
  div.innerHTML = str
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/ /g, '&nbsp;')
    .replace(/\r/g, '&#13;')
    .replace(/\n/g, '&#10;');
  return div.textContent || div.innerText;
}

class MultiDepartment extends Component {
  constructor() {
    super();

    this.state = {
      deptData: DEPT_DATA,
      deptHierarchy: DEPT_HIERARCHY
    };
  }

  createTable() {
    let table = [];
    for (let i = 0; i < this.state.deptData.length; i++) {
      var deptPath = CONFIG.APP_ROUTE + '/?dept=' + this.state.deptData[i].id;
      deptPath = deptPath.replace('//', '/');
      table.push(
        <tr>
          <td>
            <Link to={deptPath} target="_self">
              {unescapeHTML(this.state.deptData[i].dept)}
            </Link>
          </td>
        </tr>
      );
    }

    return (
      <Table style={{marginBottom: 0}}>
        <tbody>{table}</tbody>
      </Table>
    );
  }

  addHierarchicalElement(depts, depth) {
    if (!depts) {
      return;
    }
    if (depth === undefined) {
      depth = 0;
    }
    let table = [];
    for (let i = 0; i < depts.length; i++) {
      let elm = {};
      elm['text'] = unescapeHTML(depts[i].name);
      if (depts[i].children && depts[i].children.length > 0) {
        elm['nodes'] = this.addHierarchicalElement(depts[i].children, depth + 1);
      }
      table.push(elm);
    }
    return table;
  }

  createTableWithHierarchy() {
    let table = [];
    table = this.addHierarchicalElement(this.state.deptHierarchy);
    table.push({text: NOT_APPLICABLE});
    return <TreeView id="treeview" data={table} selectable={false} enableLinks={true} onClick={this.onClick} />;
  }

  navigateToMainPage(name) {
    let deptName = name;
    let location;
    if (deptName !== NOT_APPLICABLE) {
      if (this.props.uid) {
        location = CONFIG.APP_ROUTE + '/?dept=' + this.deptNameToId(deptName) + '&uid=' + this.props.uid;
      } else {
        location = CONFIG.APP_ROUTE + '/?dept=' + this.deptNameToId(deptName);
      }
    } else {
      if (this.props.uid) {
        location = CONFIG.APP_ROUTE + '/?ignore_dept=true' + '&uid=' + this.props.uid;
        this.setState({deptData: []});
      } else {
        location = CONFIG.APP_ROUTE + '/?ignore_dept=true';
        this.setState({deptData: []});
      }
    }

    window.location.href = location;
  }

  treeClick(target) {
    this.navigateToMainPage($(target).text().trim());
  }

  onClick(target, event) {
    this.navigateToMainPage(event.text.trim());
  }

  deptNameToId(name) {
    let dept = DEPT_DATA.find((object) => {
      return unescapeHTML(object.dept) === name;
    });
    return dept.id;
  }

  render() {
    let deptTable;
    if (this.state.deptHierarchy && this.state.deptHierarchy.length > 0) {
      deptTable = this.createTableWithHierarchy();

      let self = this;
      $(document).on('click', '.treeview a', function (event) {
        self.treeClick(this, event);
      });
    } else {
      deptTable = this.createTable();
    }

    let split_msg = CONFIG.MULTI_DEPT_MESSAGE.split('\n');
    let multi_dept_message = [];
    for (let i = 0; i < split_msg.length; i++) {
      multi_dept_message.push(split_msg[i]);
      multi_dept_message.push(<br />);
    }
    multi_dept_message.pop();
    return (
      <div className="container">
        <AppAlert />
        <AppNavbar gotoQuestionPanel={this.handleHomeButton} />
        <div className="center">
          <Image
            src={CONFIG.BASE_STATIC_URL + 'images/qa_character_default.png'}
            responsive="true"
            style={{display: 'inline-block', height: '200px'}}
          />
        </div>
        <div style={divStyle}>
          <p style={messageStyle}>
            {multi_dept_message}
            <br />
            以下から選択してください。
          </p>
          {deptTable}
        </div>
      </div>
    );
  }

  handleHomeButton() {
    // ホームボタンを押したときの処理
    window.location.reload();
  }

  componentDidMount() {
    $('li.list-group-item').each(function () {
      $(this).children('*:not(ul)').wrapAll('<div class="node"></div>');
    });

    // 起動時に閉じた状態にする
    $('.node .material-symbols').trigger('click');

    // ＋クリック時に子要素を閉じる
    $('.node .material-symbols').on('click', (event) => {
      let self = event.target;
      setTimeout(function () {
        $(self).closest('.node').nextAll().find('.material-symbols').trigger('click');
      }, 0);
    });
  }

  componentDidUpdate() {
    $('li.list-group-item').each(function () {
      $(this).children('*:not(ul)').wrapAll('<div class="node"></div>');
    });
    $('.node .glyphicon-minus').click();
  }
}
MultiDepartment.propTypes = {
  uid: PropTypes.string
};

export default MultiDepartment;
